import type { OrganizationFrame } from "@kontextwerk/control-web-client"
import { openOverlay } from "@kontextwerk/web-sdk/core/overlay/globalStores"
import CalendarIntegrationManagementOverlay from "../_modules/calendar-integration-management-overlay"

export const openCalendarIntegrationManagementOverlay = ({
  organization,
  allowedEmployeeIds,
  manageAllowedEmployeeIds,
  currentUserId,
}: {
  organization: OrganizationFrame | null
  allowedEmployeeIds?: string[] | null
  manageAllowedEmployeeIds?: string[] | null
  currentUserId?: string | null
}) => {
  openOverlay({
    title: "Kalenderintegrationen verwalten",
    content: CalendarIntegrationManagementOverlay,
    isDark: true,
    properties: { organization, allowedEmployeeIds, manageAllowedEmployeeIds, currentUserId },
  })
}
